import React from 'react';
import { headingPropTypes } from './HeadingPropTypes';
import * as styles from './Heading.module.scss';
const Heading = ({
  heading
}) => {
  if (!heading) {
    return null;
  }
  return /*#__PURE__*/React.createElement("p", {
    className: styles.root
  }, heading);
};
export default Heading;